import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EfficiencyTransport } from '../models';
import { StackingPlanReviewer } from '../stacking-plan.model';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'sp-stacking-plan-container',
  templateUrl: './stacking-plan-container.component.html',
  styleUrls: ['./stacking-plan-container.component.scss'],
  standalone: false,
})
export class StackingPlanContainerComponent {
  @Input() reviewerData: StackingPlanReviewer = { reviewedBy: '', reviewedOn: '' };
  @Output() createNewRecord: EventEmitter<EfficiencyTransport> = new EventEmitter();
}
